import { GlobalStateShape } from 'store';

export default {
	isMobileVisible: false
} as GlobalStateShape;
